<!--产品管理 产品列表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" placeholder="请输入产品名称" v-model="searchForm.name" clearable @clear="clearEvent()"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" placeholder="请输入产品编码" v-model="searchForm.code" clearable @clear="clearEvent()"></el-input>
          </el-form-item>
          <el-form-item label="分类：">
            <el-select size="medium" v-model="searchForm.CATALOG_ID" clearable filterable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select size="medium" v-model="searchForm.status">
              <el-option v-for="item in STATUS_LIST" :key="item.ID" :label="item.name" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select size="medium" v-model="searchForm.NEED_MORE_INFO" clearable>
              <el-option v-for="item in AUDIT_STATUS_LIST" :key="item.ID" :label="item.name" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产厂家：">
            <el-select size="medium" v-model="searchForm.SOURCE_COMPANY_ID" clearable>
              <el-option v-for="item in sourceCompanyList" :key="item.SOURCE_ID" :label="item.SOURCE_COMPANY" :value="item.SOURCE_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="searchTable()">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="small" @click="matchSku">匹配SKU</el-button>
        <el-button size="small" @click="BatchImportSku">批量新增产品</el-button>
        <el-button size="small" @click="BatchDelSku">批量删除SKU</el-button>
        <el-button size="small" @click="openExportDialog">批量导入产品</el-button>
        <el-button size="small" type="primary" plain @click="handleExportSKU()">导出</el-button>
        <el-button size="small" type="primary" plain @click="openExportSystemSKUDialog">导出系统SKU库</el-button>
        <el-button size="small" type="primary" plain @click="productionEnterpriseManagement" v-if="fun_dic[1002510]">生产企业管理</el-button>
        <el-button size="small" @click="handleBatchBtn">{{ batchBtnText }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px"
          :key="batchMode ? 'batch' : 'normal'" ref="skuTable" row-key="ID"
          @selection-change="handleSelectionChange" @select-all="handleSelectAll" @row-click="handleRowClick">
          <el-table-column type="index" width="50" label="序号" v-if="!batchMode" column-key="index"></el-table-column>
          <el-table-column type="selection" width="50" v-if="batchMode" reserve-selection align="center"
            :selectable="canSelectRow" column-key="selection"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="编码" min-width="150"></el-table-column>
          <el-table-column prop="SHORT_NAME" label="名称"></el-table-column>
          <el-table-column prop="BRAND" label="品牌"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格"></el-table-column>
          <el-table-column prop="TYPE_UNIT" width="80" label="单位"></el-table-column>
          <el-table-column prop="SOURCE_COMPANY" width="80" label="生产企业"></el-table-column>
          <el-table-column prop="DECLARE_TYPE_NAME" width="80" label="备货方案"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="所属分类"></el-table-column>
          <template>
            <el-table-column prop="PIC_URL" label="图片" width="100px">
              <template slot-scope="scope">
                <img style="width: 60px; height: 60px" src="https://service.linkda.com.cn/productImg.jpg" :data-src="scope.row.PIC_URL" alt="图片"
                  onerror="this.src='https://service.linkda.com.cn/productImg.jpg';this.onerror=null" />
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="WZ_TYPE_NAME" label="温区"></el-table-column>
          <el-table-column prop="SAFETY_STOCK" label="安全库存"></el-table-column>
          <el-table-column label="常购" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.IS_FREQUENT === 1" size="mini" type="success">常购</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="BUYED_PRODUCT_CODE" label="购买产品编码" min-width="150"></el-table-column>
          <el-table-column prop="BUYED_NAME" label="购买产品"></el-table-column>
          <el-table-column prop="BUYED_TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="BUY_RATE" label="出成比例"></el-table-column>
          <el-table-column prop="NEED_MORE_INFO" label="审核状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.NEED_MORE_INFO === 1 ? 'danger' : ''">
                {{AUDIT_STATUS_LIST[scope.row.NEED_MORE_INFO].name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="360px">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detailData(scope.row)">详情</el-button>
              <el-button type="text" size="small" @click="barCode(scope.row)">绑定条形码</el-button>
              <el-button type="text" size="small" @click="commodityCode(scope.row)">商品码</el-button>
              <el-button type="text" size="small" @click="openShop(scope.row)">购买产品</el-button>
              <el-button type="text" size="small" @click="updateData(scope.row)">
                {{ scope.row.NEED_MORE_INFO === 0 ? '修改' : '审核' }}</el-button>
              <el-button type="text" size="small" v-show="scope.row.STATUS === 0" @click="startData(scope.row)">启用</el-button>
              <el-button type="text" size="small" v-show="scope.row.STATUS === 1" @click="stopData(scope.row)" style="color:#F56C6C">禁用</el-button>
              <el-button type="text" size="small" @click="delData(scope.row)" style="color:#F56C6C">删除</el-button>
              <el-button type="text" size="small" @click="viewQualification(scope.row)">查看资质</el-button>
              <el-button type="text" size="small" @click="toggleFrequent(scope.row)">
                {{ frequentBtnText(scope.row) }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :title="updateForm.NEED_MORE_INFO === 0 ? '修改SKU' : '完善SKU信息'" center :visible.sync="updateFormVisible" width="700px"
      :close-on-click-modal="false">
      <el-form :model="updateForm" ref="updateForm" size="small" class="el-form--label-justify" label-suffix="：">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品分类" :label-width="formLabelWidth">
              <el-select v-model="updateForm.CATALOG_ID" style="width:80%">
                <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="重量" :label-width="formLabelWidth" prop="weight">
              <el-input v-model="updateForm.WEIGHT" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="温区" :label-width="formLabelWidth">
              <el-select v-model="updateForm.WZ_TYPE_ID" style="width:80%">
                <el-option v-for="item in WZ_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="销项税率" :label-width="formLabelWidth">
              <el-input v-model="updateForm.OUTPUT_VAT" style="width: 80%">
                <span slot="append">%</span>
              </el-input>
            </el-form-item>
            <el-form-item label="出库方式" :label-width="formLabelWidth">
              <el-select v-model="updateForm.OW_TYPE" style="width:80%">
                <el-option v-for="item in wayOut" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预警期" :label-width="formLabelWidth">
              <el-input v-model="updateForm.WARNING_PERIOD" style="width:50%"></el-input>
              <el-select v-model="updateForm.WP_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地" :label-width="formLabelWidth" prop="weight">
              <el-cascader v-model="updateForm.PRODUCING_AREA_CODE" style="width:80%" :options="options" @change="handleChange" placeholder="请选择产地">
              </el-cascader>
            </el-form-item>
            <el-form-item label="生产企业" :label-width="formLabelWidth" prop="weight">
              <el-select v-model="updateForm.SOURCE_COMPANY_ID" style="width:80%">
                <el-option v-for="item in sourceCompanyList" :key="item.SOURCE_ID" :label="item.SOURCE_COMPANY" :value="item.SOURCE_ID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体积" :label-width="formLabelWidth" prop="volume">
              <el-input v-model="updateForm.VOLUME" style="width: 80%"></el-input>
            </el-form-item>
            <el-form-item label="进项税率" :label-width="formLabelWidth">
              <el-input v-model="updateForm.INPUT_VAT" style="width: 80%">
                <span slot="append">%</span>
              </el-input>
            </el-form-item>
            <el-form-item label="保质期" :label-width="formLabelWidth">
              <el-input v-model="updateForm.QGP" style="width:50%"></el-input>
              <el-select v-model="updateForm.QGP_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下架期" :label-width="formLabelWidth">
              <el-input v-model="updateForm.PULL_OFF_PERIOD" style="width:50%"></el-input>
              <el-select v-model="updateForm.PO_TIME_TYPE" style="width:30%">
                <el-option v-for="item in date_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安全库存" :label-width="formLabelWidth">
              <el-input v-model="updateForm.SAFETY_STOCK" style="width:80%"></el-input>
            </el-form-item>
            <el-form-item label="库位编码" :label-width="formLabelWidth">
              <el-select v-model="updateForm.DEFAULT_LOCATION_ID" style="width:80%">
                <el-option v-for="item in positionLi" :key="item.ID" :label="item.CODE" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报货方案" :label-width="formLabelWidth">
              <el-select v-model="updateForm.DECLARE_TYPE" style="width:80%" clearable>
                <el-option v-for="item in PlanList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row v-if="updateForm.NEED_MORE_INFO === 0" style="display: flex; flex-wrap: wrap;">
          <el-form-item :label="`产品别名${ updateForm.PRODUCT_ALIAS_NAME_LIST.length == 1 ? '' : index + 1}`"
            v-for="x, index in updateForm.PRODUCT_ALIAS_NAME_LIST" :key="index" :label-width="formLabelWidth" style="width: 50%;">
            <el-input v-model="x.ALIAS_NAME" style="width: 80%">
              <el-button v-if="index == updateForm.PRODUCT_ALIAS_NAME_LIST.length - 1" type="text" slot="append" @click="addProductAliasName"
                icon="el-icon-circle-plus-outline" style="margin-right: 0 !important; font-size: large;">
              </el-button>
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateFormVisible = false">取 消</el-button>
        <el-button v-if="updateForm.NEED_MORE_INFO === 0" size="small" @click="submitUpdate" :loading="editLoading">确 定</el-button>
        <el-button v-else size="small" @click="completeInformation" :loading="editLoading" v-preventReClick>确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量导入SKU -->
    <el-dialog :visible.sync="importSKUDialog" title="批量导入SKU" @close="closeImport" width="450px" center>
      <el-form ref="importSKUForm" v-model="importSKUForm">
        <el-form-item label="团餐公司：" :label-width="formLabelWidth" v-if="fun_dic[1002509]">
          <el-select filterable v-model="importSKUForm.tc_name" multiple collapse-tags placeholder="请选择" style="width:80%">
            <el-option v-for="item in tcName" :key="item.TC_ID" :label="item.TC_NAME" :value="item.TC_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件：" :label-width="formLabelWidth">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.importSKUForm.fileUrl"
            multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <p @click="downLoadImportSKU" style="color: #409EFF;cursor: pointer">点击下载导入模板</p>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="closeImport">取消</el-button>
        <el-button class="operate-btn" @click="submitBatchImportSKU">确认</el-button>
      </div>
    </el-dialog>
    <!-- 批量删除SKU -->
    <el-dialog :visible.sync="delSKUDialog" title="批量删除SKU" @close="closeDel" width="450px" center>
      <el-form ref="delSKUForm" v-model="delSKUForm">
        <el-form-item label="上传文件：" :label-width="formLabelWidth">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.delSKUForm.fileUrl"
            multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <p @click="downLoadDelSKU" style="color: #409EFF;cursor: pointer">点击下载导入模板</p>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="closeDel">取消</el-button>
        <el-button class="operate-btn" @click="submitDelSKU">确认</el-button>
      </div>
    </el-dialog>
    <!-- 设置购买产品 -->
    <el-dialog title="修改购买产品" center :visible.sync="buyFormVisible" width="500px">
      <el-form ref="buyForm" v-model="buyForm" style="margin-left: 30px" label-width="100px">
        <el-form-item label="购买产品：">
          <el-autocomplete class="inline-input" v-model="buyForm.productName" :fetch-suggestions="querySearchProduct" placeholder="请输入产品名称"
            :trigger-on-focus="false" @select="handleSelect" clearable style="width: 100%">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="出成比例：">
          <el-input v-model="buyForm.BUY_RATE"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBuy('buyForm')">取 消</el-button>
        <el-button @click="submitBuy('buyForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 绑定条形码 -->
    <el-dialog title="绑定条形码" center :visible.sync="barCodeVisible" width="500px">
      <el-form ref="barCodeForm" v-model="barCodeForm" label-width="100px">
        <el-form-item label="条形码：">
          <el-input v-model="barCodeForm.BAR_CODE" style="width: 300px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="barCodeVisible = false">取 消</el-button>
        <el-button @click="submitBarCode()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量导入产品 -->
    <el-dialog :visible.sync="exportDialog" title="批量导入产品" @close="exportDialog = false" width="450px" center>
      <el-radio-group v-model="importType" @change="typeChange" style="margin: 35px">
        <el-radio :label="1">多分类导入</el-radio>
        <el-radio :label="2">单一分类导入</el-radio>
      </el-radio-group>
      <el-form ref="importCommonSKUForm" v-model="importCommonSKUForm" v-if="importType == 1">
        <el-form-item label="团餐公司：" :label-width="formLabelWidth" v-if="fun_dic[1002509]">
          <el-select filterable v-model="importCommonSKUForm.tc_name" multiple collapse-tags placeholder="请选择" style="width:80%">
            <el-option v-for="item in tcName" :key="item.TC_ID" :label="item.TC_NAME" :value="item.TC_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件：" :label-width="formLabelWidth">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
            :name="this.importCommonSKUForm.fileUrl" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <p @click="downLoadImportCommonSKU" style="color: #409EFF;cursor: pointer">点击下载导入模板</p>
        </el-form-item>
      </el-form>
      <el-form ref="exportSKUForm" v-model="exportSKUForm" v-if="importType == 2">
        <el-form-item label="产品分类：" :label-width="formLabelWidth">
          <el-select v-model="exportSKUForm.CATALOG_ID" style="width:80%" filterable>
            <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团餐公司：" :label-width="formLabelWidth" v-if="fun_dic[1002509]">
          <el-select filterable v-model="exportSKUForm.tc_name" multiple collapse-tags placeholder="请选择" style="width:80%">
            <el-option v-for="item in tcName" :key="item.TC_ID" :label="item.TC_NAME" :value="item.TC_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件：" :label-width="formLabelWidth">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :name="this.exportSKUForm.fileUrl" multiple :limit="1"
            accept=".xls,.xlsx" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <p @click="downLoadSKU" style="color: #409EFF;cursor: pointer">点击下载导入模板</p>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="exportDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitImportForm">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" width="600px">
      <div style="margin:0 auto;">
        <img :src="this.imgUrl" style="width:550px;height:500px;">
      </div>
    </el-dialog>
    <!-- 导出系统SKU -->
    <el-dialog :visible.sync="exportSystemSKUDialog" title="导出系统SKU" @close="exportSystemSKUDialog = false" width="400px" center
      :close-on-click-modal="false">
      <el-checkbox v-model="checked" @change="selectAll">全选</el-checkbox>
      <el-tree :props="props" :data="treeData" node-key="CODE" show-checkbox accordion ref="tree" :default-checked-keys="this.allData"></el-tree>
      <div slot="footer" style="text-align: center">
        <el-button v-preventReClick class="operate-btn" @click="exportSystemSKUDialog = false">取消</el-button>
        <el-button v-preventReClick class="operate-btn" @click="exportSystemSKU" v-loading="exportLoading">确认
        </el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { provinceAndCityData, CodeToText, TextToCode } from 'element-china-area-data';
import {
  queryUseSKU, startUseSKU, stopUseSKU, updateUseSku, queryWQ, ExportSKU, enterSKU, BatchImportSku, BatchDelSku, queryShopSKU, addShopSKUFun, getClassFun, delUseSKUFun, ImportCommonSKU, setFrequentSku,
} from '@/assets/api/skuManage';
import { queryPosition } from '@/assets/api/warehouseManager';
import { frontEndFun } from '@/assets/api/frontFun';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  mounted() {
    this.lazyLoadImages();
    window.addEventListener('scroll', this.throttledLazyLoadImages);
  },
  data() {
    return {
      sourceCompanyList: [],
      PAGE_ID: '10025', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        1002501: 0, 1002502: 0, 1002503: 0, 1002504: 0, 1002505: 0, 1002506: 0, 1002507: 0, 1002508: 0, 1002509: 0, 1002510: 0,
      },
      formLabelWidth: '120px',
      date_list: [
        {
          ID: 1,
          NAME: '年',
        }, {
          ID: 2,
          NAME: '季',
        }, {
          ID: 3,
          NAME: '月',
        }, {
          ID: 4,
          NAME: '日',
        }, {
          ID: 5,
          NAME: '时',
        },
      ],
      WZ_list: [], // 温区
      wayOut: [
        {
          ID: 1,
          NAME: 'MTO',
        }, {
          ID: 2,
          NAME: 'MTS',
        }, {
          ID: 3,
          NAME: 'DS',
        },
      ],
      updateFormVisible: false,
      editLoading: false,
      STATUS_LIST: [
        {
          ID: 0,
          name: '禁用',
        }, {
          ID: 1,
          name: '启用',
        },
      ],
      fileList: [],
      searchForm: {
        status: 1,
      },
      updateForm: {},
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      exportSKUForm: {
        fileUrl: 'tmp',
        tc_name: [],
      },
      importSKUForm: {
        fileUrl: 'tmp',
        tc_name: [],
      },
      importSKUDialog: false,
      importCommonSKUForm: {
        fileUrl: 'tmp',
        tc_name: [],
      },
      file_name: '',
      positionLi: [],
      buyForm: {},
      buyFormVisible: false,
      catalogList: [],
      PlanList: [],
      delSKUDialog: false,
      delSKUForm: {
        fileUrl: 'tmp',
      },
      AUDIT_STATUS_LIST: [
        {
          ID: 0,
          name: '已审核',
        },
        {
          ID: 1,
          name: '待审核',
        },
      ],
      imgUrl: '',
      dialogVisible: false,
      barCodeForm: {},
      barCodeVisible: false,
      exportSystemSKUDialog: false,
      checked: true,
      exportLoading: false,
      treeData: [],
      allData: [],
      props: {
        label: 'label',
        children: 'children',
      },
      tcName: [],
      exportDialog: false,
      importType: 1,
      batchMode: false,
      batchSelection: [],
      options: provinceAndCityData,
    };
  },
  created() {
    this.queryPurchasePlan(); // 拉取报货方案
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryBeforeFun();
    if (this.SKU_USED_DATA_CONDITION.CONDITION) {
      this.searchForm = this.SKU_USED_DATA_CONDITION.CONDITION;
      this.tableData = this.SKU_USED_DATA_CONDITION.DATA;
      this.currentPage = this.SKU_USED_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
    this.queryCatalog();
    this.queryTCName();
    this.querySourceCompany();
  },
  computed: {
    SKU_USED_DATA_CONDITION() {
      return this.$store.state.SKU_USED_DATA_CONDITION;
    },
    // 批量按钮文案：未进入→批量常购；已进入未勾选→退出批量；已勾选→按首个勾选项状态取反显示提交动作
    batchBtnText() {
      if (!this.batchMode) {
        return '批量常购';
      }
      if (this.batchSelection.length === 0) {
        return '退出批量';
      }
      const count = this.batchSelection.length;
      return Number(this.batchSelection[0].IS_FREQUENT) === 1 ? `确定取消常购(${count})` : `确定设为常购(${count})`;
    },
    throttledLazyLoadImages() {
      return this.throttle(this.lazyLoadImages, 200);
    },
  },
  methods: {
    querySourceCompany() {
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 52,
        COMPANY_ID: Number(sessionStorage.getItem('tcId')), // 生产企业ID
        COMPANY_TYPE: 2, // 公司类型（1：团餐，2：供应商）
      };

      http.post(params).then((res) => {
        this.sourceCompanyList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    productionEnterpriseManagement() {
      this.$router.push({ path: '/productionEnterpriseManagement' });
    },
    // 图片懒加载
    lazyLoadImages() {
      const images = document.querySelectorAll('img[data-src]');

      images.forEach((img) => {
        const rect = img.getBoundingClientRect();

        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      });
    },

    throttle(func, limit) {
      let inThrottle;
      return function (...args) {
        const context = this;

        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;

          setTimeout(() => {
            inThrottle = false;
          }, limit);
        }
      };
    },
    // 拉取 报货方案
    queryPurchasePlan() {
      const params = {
        SERVICE_ID: '10074',
        OTYPE: 13,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result[0].OP_ROLE.length !== 0) {
          this.PlanList = result[0].OP_ROLE;
        } else {
          this.PlanList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取团餐公司信息列表
    queryTCName() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 26,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        if (result) {
          this.tcName = result;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    clearEvent() {
      this.queryTable();
    },
    // 商品码
    commodityCode(row) {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 23,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      http.post(params).then((result) => {
        this.imgUrl = result[0];
        this.dialogVisible = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 绑定条形码
    barCode(row) {
      this.barCodeForm = row;
      this.barCodeVisible = true;
    },
    submitBarCode() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 22,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUP_ID: this.barCodeForm.ID,
        BAR_CODE: this.barCodeForm.BAR_CODE,
      };
      if (!this.barCodeForm.BAR_CODE) {
        this.$message.show({ text: '请输入条形码', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.queryTable();
        this.$message.show({ text: '绑定成功', type: 'success' });
        this.barCodeVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 拉取温区
    queryWZ() {
      queryWQ()
        .then((result) => {
          this.WZ_list = result;
        }).catch((error) => {
        });
    },
    // 匹配sku
    matchSku() {
      this.$router.push({ path: '/matchSku/detail' });
    },
    // 查看详情
    detailData(row) {
      sessionStorage.setItem('detailData', JSON.stringify(row));
      this.$router.push({ path: '/skuDetail/detail' });
    },
    // 修改
    updateData(row) {
      this.queryWZ();
      this.updateForm = { ...row, PRODUCT_ALIAS_NAME_LIST: row.PRODUCT_ALIAS_NAME ? row.PRODUCT_ALIAS_NAME.split(',').map((x) => ({ ALIAS_NAME: x })) : [{ ALIAS_NAME: '' }] };

      let PRODUCING_AREA_CODE = [];
      try {
        if (row.PRODUCING_AREA) {
          const list = row.PRODUCING_AREA.split('/');
          PRODUCING_AREA_CODE.push(TextToCode[list[0]].code);
          PRODUCING_AREA_CODE.push(TextToCode[list[0]][list[1]].code);
        }
      } catch (_e) {
        row.PRODUCING_AREA = '';
        PRODUCING_AREA_CODE = [];
      }
      Object.assign(this.updateForm, {
        PRODUCING_AREA_CODE,
      });
      this.updateFormVisible = true;
      queryPosition().then((res) => {
        this.positionLi = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 提交修改
    submitUpdate() {
      this.editLoading = true;
      const params = {
        PRODUCT_CODE: this.updateForm.PRODUCT_CODE,
        WZ_TYPE_ID: this.updateForm.WZ_TYPE_ID,
        OW_TYPE: this.updateForm.OW_TYPE,
        QGP: Number(this.updateForm.QGP),
        QGP_TIME_TYPE: this.updateForm.QGP_TIME_TYPE,
        WARNING_PERIOD: Number(this.updateForm.WARNING_PERIOD),
        WP_TIME_TYPE: this.updateForm.WP_TIME_TYPE,
        PULL_OFF_PERIOD: this.updateForm.PULL_OFF_PERIOD ? this.updateForm.PULL_OFF_PERIOD : 0,
        PO_TIME_TYPE: this.updateForm.PO_TIME_TYPE,
        INPUT_VAT: Number(this.updateForm.INPUT_VAT),
        OUTPUT_VAT: Number(this.updateForm.OUTPUT_VAT),
        DEFAULT_LOCATION_ID: this.updateForm.DEFAULT_LOCATION_ID,
        CATALOG_ID: this.updateForm.CATALOG_ID,
        SAFETY_STOCK: this.updateForm.SAFETY_STOCK,
        VOLUME: this.updateForm.VOLUME ? this.updateForm.VOLUME : 0,
        WEIGHT: this.updateForm.WEIGHT ? this.updateForm.WEIGHT : 0,
        PRODUCING_AREA: this.updateForm.PRODUCING_AREA,
        DECLARE_TYPE_ID: this.updateForm.DECLARE_TYPE ? this.updateForm.DECLARE_TYPE : 0,
        SOURCE_COMPANY_ID: this.updateForm.SOURCE_COMPANY_ID ? this.updateForm.SOURCE_COMPANY_ID : 0,
        PRODUCT_ALIAS_NAME: this.updateForm.PRODUCT_ALIAS_NAME_LIST.map((x) => x.ALIAS_NAME).join(','),
      };
      updateUseSku(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editLoading = false;
        this.queryTable();
        this.updateFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.editLoading = false;
      });
    },
    // 拉取
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        STATUS: this.searchForm.status,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.NEED_MORE_INFO) {
        params.NEED_MORE_INFO = this.searchForm.NEED_MORE_INFO;
      }
      if (this.searchForm.SOURCE_COMPANY_ID) params.SOURCE_COMPANY_ID = this.searchForm.SOURCE_COMPANY_ID;
      queryUseSKU(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list.map((item) => Object.assign(item, { PIC_URL: `https://service.linkda.com.cn/file/productImages/${item.PRODUCT_CODE}.png` }));
            this.totalCount = result[0].TOTAL_COUNT;
            this.$store.dispatch('SET_SKU_USED_DATA_CONDITION', {
              CONDITION: this.searchForm,
              DATA: this.tableData,
              TOTAL_COUNT: this.totalCount,
              CURRENT_PAGE: this.currentPage,
            });
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
            this.tableData = [];
            this.totalCount = 0;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    // 筛选
    searchTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 表格勾选变化（批量模式）
    handleSelectionChange(selection) {
      this.batchSelection = selection;
    },
    // 批量模式下点击行内非交互区域：直接切换该行选中状态
    handleRowClick(row, column) {
      if (!this.batchMode || !column) {
        return;
      }
      // 操作列（按钮/空白）、图片列不处理；勾选列 checkbox 自身已阻止冒泡，其余区域均可点击切换
      if (column.label === '操作' || column.label === '图片') {
        return;
      }
      if (!this.canSelectRow(row)) {
        this.$message.show({ text: '常购与非常购产品不能混选', type: 'warning' });
        return;
      }
      // 与点击 checkbox 完全一致的内部路径：保证表头全选态同步刷新
      this.$refs.skuTable.store.commit('rowSelectedChanged', row);
    },
    // 勾选约束：仅与首个勾选项同类型（常购/非常购）的行可勾选，其余置灰
    canSelectRow(row) {
      if (this.batchSelection.length === 0) {
        return true;
      }
      const baseFlag = Number(this.batchSelection[0].IS_FREQUENT) === 1 ? 1 : 0;
      return (Number(row.IS_FREQUENT) === 1 ? 1 : 0) === baseFlag;
    },
    // 表头全选兜底：首次全选时 selectable 来不及约束，混合类型时自动撤掉不一致的行
    handleSelectAll(selection) {
      if (selection.length === 0) {
        return;
      }
      const baseFlag = Number(selection[0].IS_FREQUENT) === 1 ? 1 : 0;
      const mismatched = selection.filter((item) => (Number(item.IS_FREQUENT) === 1 ? 1 : 0) !== baseFlag);
      if (mismatched.length === 0) {
        return;
      }
      mismatched.forEach((row) => {
        this.$refs.skuTable.toggleRowSelection(row, false);
      });
      this.$message.show({ text: '常购与非常购产品不能混选，已自动取消不一致的行', type: 'warning' });
    },
    // 批量按钮：进入批量 → 未勾选点击退出 → 已勾选点击提交
    handleBatchBtn() {
      if (!this.batchMode) {
        this.batchMode = true;
        this.batchSelection = [];
        return;
      }
      if (this.batchSelection.length === 0) {
        this.exitBatchMode();
        return;
      }
      this.submitBatchFrequent();
    },
    // 退出批量模式并清空选中
    exitBatchMode() {
      if (this.$refs.skuTable) {
        this.$refs.skuTable.clearSelection();
      }
      this.batchSelection = [];
      this.batchMode = false;
    },
    // 提交批量常购设置（动作 = 首个勾选项状态取反：常购→批量取消，非常购→批量设置）
    submitBatchFrequent() {
      const first = this.batchSelection[0];
      const targetFlag = Number(first.IS_FREQUENT) === 1 ? 0 : 1;
      const actionText = targetFlag === 1 ? '设为常购' : '取消常购';
      const productCodes = this.batchSelection.map((item) => item.PRODUCT_CODE);
      this.$confirm(`确定将已勾选的 ${productCodes.length} 个产品批量${actionText}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        setFrequentSku({ PRODUCT_CODES: productCodes, IS_FREQUENT: targetFlag })
          .then(() => {
            this.$message.show({ text: `批量${actionText}成功`, type: 'success' });
            this.exitBatchMode();
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消操作' });
      });
    },
    // 行内切换常购状态
    toggleFrequent(row) {
      const targetFlag = Number(row.IS_FREQUENT) === 1 ? 0 : 1;
      setFrequentSku({ PRODUCT_CODES: [row.PRODUCT_CODE], IS_FREQUENT: targetFlag })
        .then(() => {
          this.$message.show({ text: targetFlag === 1 ? '已设为常购' : '已取消常购', type: 'success' });
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 行内常购按钮文案
    frequentBtnText(row) {
      return Number(row.IS_FREQUENT) === 1 ? '取消常购' : '设为常购';
    },
    // 启用
    startData(row) {
      this.$confirm('确定启用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          PRODUCT_CODE: row.PRODUCT_CODE,
        };
        startUseSKU(params)
          .then((result) => {
            this.$message.show({ text: '启用成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消启用' });
      });
    },
    // 禁用
    stopData(row) {
      this.$confirm('确定禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          PRODUCT_CODE: row.PRODUCT_CODE,
        };
        stopUseSKU(params)
          .then((result) => {
            this.$message.show({ text: '禁用成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消禁用' });
      });
    },
    viewQualification(row) {
      this.$router.push({ path: '/productQualification' });
      sessionStorage.setItem('常用SKU当前行信息', JSON.stringify(row));
    },
    delData(row) {
      this.$confirm('确定删除该在用产品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          PRODUCT_ID: row.ID,
          CATALOG_ID: row.CATALOG_ID,
        };
        delUseSKUFun(params)
          .then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消操作' });
      });
    },
    handleSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.file_name = '';
    },
    submitImportSKU() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FILE_NAME: this.file_name,
            CATALOG_ID: this.exportSKUForm.CATALOG_ID,
          };
          if (this.exportSKUForm.tc_name.length != 0) {
            params.TC_ID = this.exportSKUForm.tc_name;
          }
          enterSKU(params).then((result) => {
            if (result[0].FILE_PATH) {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              this.$message.show({ text: '部分产品导入失败，详情请查看表格', type: 'warning' });
            } else {
              this.$message.show({ text: '提交成功', type: 'success' });
            }
            this.importSKUDialog = false;
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 模板下载
    downLoadSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/gysUsingCatalogSKUTemp.xls';
    },
    // 批量新增SKU
    BatchImportSku() {
      this.importSKUDialog = true;
    },
    downLoadImportSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/SMPBatchImportSkuTemplateForTest.xls';
    },
    submitBatchImportSKU() {
      if (!this.file_name) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        FILE_PATH: this.file_name,
      };
      if (this.importSKUForm.tc_name.length != 0) {
        params.TC_ID = this.importSKUForm.tc_name;
      }
      BatchImportSku(params).then((result) => {
        if (result[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          this.$message.show({ text: '导入结果请查看文件', type: 'success' });
        } else {
          this.$message.show({ text: '提交成功', type: 'success' });
        }
        this.file_name = '';
        this.fileList = [];
        this.importSKUDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.file_name = '';
        this.fileList = [];
      });
    },
    closeImport() {
      this.importSKUDialog = false;
    },
    // 批量删除SKU
    BatchDelSku() {
      this.delSKUDialog = true;
    },
    downLoadDelSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/TemplateForDelete.xls';
    },
    submitDelSKU() {
      if (!this.file_name) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        FILE_PATH: this.file_name,
      };
      BatchDelSku(params)
        .then((result) => {
          this.$message.show({ text: '提交成功', type: 'success' });
          this.file_name = '';
          this.fileList = [];
          this.delSKUDialog = false;
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.fileList = [];
        });
    },
    closeDel() {
      this.delSKUDialog = false;
    },
    // 导出
    handleExportSKU() {
      const params = {};
      ExportSKU(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 提交导入常用SKU
    submitImportCommonSKU() {
      if (!this.file_name) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        FILE_NAME: this.file_name,
      };
      if (this.importCommonSKUForm.tc_name.length != 0) {
        params.TC_ID = this.importCommonSKUForm.tc_name;
      }
      ImportCommonSKU(params)
        .then((result) => {
          if (result[0].FILE_PATH != '') {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.$message.show({ text: '部分导入失败，详情请查看文件', type: 'warning' });
          } else {
            this.$message.show({ text: '提交成功', type: 'success' });
          }
          this.file_name = '';
          this.fileList = [];
          this.importSKUDialog = false;
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.file_name = '';
          this.fileList = [];
        });
    },
    // 下载批量导入常用SKU模板
    downLoadImportCommonSKU() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/bulkImportCommonSKU.xls';
    },
    // 设置购买产品
    openShop(row) {
      this.buyForm = row;
      this.buyFormVisible = true;
    },
    // ------------------搜索
    querySearchProduct(queryString, callback) {
      const params = {
        NAME: queryString,
      };
      queryShopSKU(params).then((res) => {
        const tmpArr = res.map((item) => Object.assign(item));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    //  点击搜索结果返回选中的结果
    handleSelect(item) {
      this.PRODUCT_CODE = item.PRODUCT_CODE;
    },
    submitBuy() {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!this.buyForm.productName || !this.buyForm.BUY_RATE) {
        this.$message.show({ text: '请输入购买产品和出成比例', type: 'warning' });
        return false;
      }
      if (!reg.test(this.buyForm.BUY_RATE)) {
        this.$message.show({ text: '请输入正确的出成比例', type: 'warning' });
        return false;
      }
      const params = {
        BUYED_PRODUCT_CODE: this.PRODUCT_CODE,
        DETAIL_ID: this.buyForm.ID,
        BUY_RATE: this.buyForm.BUY_RATE,
      };
      addShopSKUFun(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.buyFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeBuy() {
      this.buyFormVisible = false;
    },
    queryCatalog() {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 完善信息
    completeInformation() {
      this.editLoading = true;
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 20,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        UPDATE_ID: this.updateForm.ID,
        PRODUCT_CODE: this.updateForm.PRODUCT_CODE,
        WZ_TYPE_ID: this.updateForm.WZ_TYPE_ID,
        OW_TYPE: this.updateForm.OW_TYPE,
        QGP: Number(this.updateForm.QGP),
        QGP_TIME_TYPE: this.updateForm.QGP_TIME_TYPE,
        WARNING_PERIOD: Number(this.updateForm.WARNING_PERIOD),
        WP_TIME_TYPE: this.updateForm.WP_TIME_TYPE,
        PULL_OFF_PERIOD: this.updateForm.PULL_OFF_PERIOD ? this.updateForm.PULL_OFF_PERIOD : 0,
        PO_TIME_TYPE: this.updateForm.PO_TIME_TYPE,
        INPUT_VAT: Number(this.updateForm.INPUT_VAT),
        OUTPUT_VAT: Number(this.updateForm.OUTPUT_VAT),
        DEFAULT_LOCATION_ID: this.updateForm.DEFAULT_LOCATION_ID,
        CATALOG_ID: this.updateForm.CATALOG_ID,
        SAFETY_STOCK: this.updateForm.SAFETY_STOCK,
        VOLUME: this.updateForm.VOLUME ? this.updateForm.VOLUME : 0,
        WEIGHT: this.updateForm.WEIGHT ? this.updateForm.WEIGHT : 0,
        PRODUCING_AREA: this.updateForm.PRODUCING_AREA,
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.editLoading = false;
          this.queryTable();
          this.updateFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.editLoading = false;
        });
    },
    openExportSystemSKUDialog() {
      this.exportSystemSKUDialog = true;
      this.checked = true;
      this.queryProductCatalog();
    },
    queryProductCatalog() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 24,
      };
      http
        .post(params)
        .then((result) => {
          this.treeData = result;
          for (let i = 0; i < result.length; i++) {
            this.allData.push(result[i].CODE);
          }
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    selectAll(e) {
      if (e) {
        this.$refs.tree.setCheckedKeys(this.allData);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    exportSystemSKU() {
      this.exportLoading = true;
      const SECOND_CATALOG_ARRAY = this.$refs.tree
        .getCheckedKeys()
        .filter((word) => word >= 1000);
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 25,
        SECOND_CATALOG_ARRAY,
      };
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.exportLoading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.exportLoading = false;
      });
    },
    // 批量导入产品
    openExportDialog() {
      this.exportDialog = true;
    },
    typeChange() {
      this.$forceUpdate();
    },
    // 提交导入
    submitImportForm() {
      if (this.importType == 1) {
        this.submitImportCommonSKU();
      } else if (this.importType == 2) {
        this.submitImportSKU();
      }
    },

    handleChange(value) {
      if (value.length > 0) {
        Object.assign(this.updateForm, { PRODUCING_AREA: `${CodeToText[value[0]]}/${CodeToText[value[1]]}` });
      }
    },
    addProductAliasName() {
      const list = this.updateForm.PRODUCT_ALIAS_NAME_LIST;
      if (!list[list.length - 1].ALIAS_NAME) {
        this.$message.show({ text: `请先填写产品别名${list.length == 1 ? '' : list.length}`, type: 'warning' });
        return;
      }
      this.updateForm.PRODUCT_ALIAS_NAME_LIST.push({ ALIAS_NAME: '' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/useSku.vue